module.exports = __webpack_public_path__ + "assets/img/dzh-31.7678c615.gif";